import { render, staticRenderFns } from "./resumo-periodo.vue?vue&type=template&id=283606ae"
import script from "./resumo-periodo.vue?vue&type=script&lang=js"
export * from "./resumo-periodo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports